import { createGlobalStyle } from 'styled-components';
import { Heading } from '../theming/styles';

const GlobalStyles = createGlobalStyle`
  /* ─────────────────────────────────────────────────────────────
     Design Tokens — theme-aware (update on every theme switch)
     All static tokens live in index.css :root
  ───────────────────────────────────────────────────────────── */
  :root {
    /* ── Color: primary (blue in light, white in dark) ── */
    --color-primary:      ${({ theme }) => theme.colorPrimary};

    /* ── Color: surfaces ── */
    --color-bg:           ${({ theme }) => theme.main};
    --color-surface:      ${({ theme }) => theme.altWhite};
    --color-flip:         ${({ theme }) => theme.flip};
    --color-inverse:      ${({ theme }) => theme.inverse};

    /* ── Color: text ── */
    --color-text:         ${({ theme }) => theme.textMain};
    --color-text-muted:   ${({ theme }) => theme.textLight};
    --color-text-gray:    ${({ theme }) => theme.grayText};
    --text-color:         ${({ theme }) => theme.textMain};

    /* ── Color: UI ── */
    --color-icon-bg:      ${({ theme }) => theme.iconBg};
    --color-border:       ${({ theme }) => theme.outline};
    --color-form-bg:      ${({ theme }) => theme.formGray};
  }

  *, *::before, *::after {
    border: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: auto;
    font-weight: inherit;
    margin: 0;
    outline: 0;
    padding: 0;
    position: relative;
    text-decoration: none;
    text-rendering: optimizeLegibility;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  *:focus { outline: ${({ theme }) => theme.outline}; outline-offset: 3px; }

  html {
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 1.5;
    padding: 0;
    margin: 0;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    font-weight: 400;
    /* html background ensures no white flash on overscroll / iOS bounce */
    background: ${({ theme }) => theme.main};
  }

  body {
    background: ${({ theme }) => theme.main};
    color: ${({ theme }) => theme.textMain};
    box-sizing: border-box;
    font-family: var(--font-body);
    font-weight: 400;
    letter-spacing: -1.1%;
    width: 100%;
    min-height: 100%;
    overscroll-behavior-y: none;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar { width: 0 !important }
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  a {
    color: currentColor;
    text-decoration: none;
  }

  a:hover {
    cursor: pointer;

    ${Heading}{
      border-bottom: 2px solid;
      border-bottom-color: ${({ theme }) => theme.textMain};
    }
  }
`;

export default GlobalStyles;
